// Grooming style catalog. Keep this decoupled from UI so it can be swapped
// or fetched from an API later without changing components.

export const GROOMING_STYLES = [
  {
    id: "teddy-bear",
    name: "Teddy Bear",
    description: "Soft, rounded face and a fluffy, cuddly appearance.",
    image:
      "https://images.unsplash.com/photo-1745100549980-57be4091079d?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "cuddly",
  },
  {
    id: "puppy-cut",
    name: "Puppy Cut",
    description: "Even, manageable length with a youthful look.",
    image:
      "https://images.unsplash.com/photo-1769523371421-1524a2c74ba3?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "youthful",
  },
  {
    id: "short-summer",
    name: "Short Summer Cut",
    description: "Shorter coat for a clean, lightweight summer appearance.",
    image:
      "https://images.unsplash.com/photo-1605197161470-d0261cac6767?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "breezy",
  },
  {
    id: "fluffy-long",
    name: "Fluffy & Long",
    description: "Keep more coat length for a fuller, flowing appearance.",
    image:
      "https://images.unsplash.com/photo-1664658857429-70483bd7ae82?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "flowing",
  },
  {
    id: "rounded-face",
    name: "Rounded Face",
    description: "Emphasizes a soft, rounded facial appearance.",
    image:
      "https://images.unsplash.com/photo-1583987303344-1f553edc7f11?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "gentle",
  },
  {
    id: "sporty",
    name: "Sporty / Athletic",
    description: "Shorter, practical coat with a clean athletic appearance.",
    image:
      "https://images.unsplash.com/photo-1651273427958-bf78352e39be?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "athletic",
  },
  {
    id: "breed-inspired",
    name: "Breed-Inspired",
    description: "A style inspired by traditional grooming for your dog's breed.",
    image:
      "https://images.unsplash.com/photo-1509981540399-03322d638f79?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "classic",
  },
  {
    id: "custom",
    name: "Custom Style",
    description: "Describe the look you're imagining.",
    image:
      "https://images.unsplash.com/photo-1678673414789-143ed913bdc2?crop=entropy&cs=srgb&fm=jpg&w=800&q=80",
    tone: "custom",
  },
];

export const BODY_LENGTHS = ["Very Short", "Short", "Medium", "Long"];
export const FACE_STYLES = ["Natural", "Rounded", "Short", "Fluffy"];
export const EAR_STYLES = ["Short", "Medium", "Long"];
export const TAIL_STYLES = ["Short", "Medium", "Fluffy"];

export function getStyleById(id) {
  return GROOMING_STYLES.find((s) => s.id === id) || null;
}
